import { Injectable } from '@angular/core';
import {ProjectService, WmHttpService, BaseserviceService, I18nService, ServiceFactoryService} from "@wms/services";
import { environment } from "@wms/app";

@Injectable({
  providedIn: 'root'
})
export class FileService {
  private TARGET: string = 'FILE';
  private locale: any;
  public storeIconFamiliesList: any;
  private API_META: any = {
    remove: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/resources/content/web/:filePath",
      method: "DELETE"
    },
    uploadPrefab: {
      url: environment.SERVICES_BASE_PATH + "services/prefabs",
      method: "POST",
    },
    registerFileService: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/fileservice/register",
      method: "POST"
    },
    addFolder: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/resources/content/web/:folderPath",
      method: "PUT"
    },
    read: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/resources/content/web/:filePath",
      method: "GET",
      responseType: "text"
    },
    readDir: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/resources/info/web/:filePath",
      method: "GET"
    },
    write: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/resources/content/web/:filePath",
      method: "POST"
    },
    upload: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/resources/content/web/:filePath",
      method: "POST"
    },
  };

  constructor(private wmHttpService: WmHttpService, private projectService: ProjectService,private baseservice: BaseserviceService,private i18nService: I18nService,private serviceFactory: ServiceFactoryService) {
    this.wmHttpService.registerApiMeta(this.TARGET, this.API_META);
    this.locale = this.i18nService.getMessages();
  }

  registerFileService() {
    return (this.wmHttpService.execute({
      target: this.TARGET,
      action: 'registerFileService',
      toasterInfo: { 'error': { title: this.locale.MESSAGE_ERROR_TITLE, description: this.locale['MESSAGE_ERROR_FILE_UPLOAD_WIDGET_REGISTER_FAILED_DESC'] } },
      pathParams: {
        projectID: this.projectService.getProjectId()
      }
    }) as Promise<any>).then(() => {
      // add file service into the list of services once the registration is successfull.
      let CONSTANT_FILE_SERVICE = 'FileService';
      this.serviceFactory.addService({ name: CONSTANT_FILE_SERVICE, type: 'JavaService', sampleResponse: null });
    });
  }

  readDir(dirPath: string ,showSpinner:boolean = true): Promise<any> {
    return (this.wmHttpService.execute({
      target: this.TARGET,
      action: 'readDir',
      pathParams: {
        projectID: this.projectService.getProjectId(),
        filePath: dirPath
      },
      spinnerInfo: {
        showSpinner: showSpinner
      }
    }) as Promise<any>);
  }

  addDir(dirPath: string): Promise<any> {
    return (this.wmHttpService.execute({
      target: this.TARGET,
      action: 'addFolder',
      pathParams: {
        projectID: this.projectService.getProjectId(),
        folderPath: dirPath
      }
    }) as Promise<any>);
  }

  read(filePath: string, useCache: boolean = false): Promise<any> {
    return (this.wmHttpService.execute({
      target: this.TARGET,
      action: 'read',
      useCache: useCache,
      pathParams: {
        projectID: this.projectService.getProjectId(),
        filePath: filePath
      }
    }) as Promise<any>);
  }

  remove(path: string): Promise<any> {
    return (this.wmHttpService.execute({
      target: this.TARGET,
      action: 'remove',
      pathParams: {
        projectID: this.projectService.getProjectId(),
        filePath: path
      }
    }) as Promise<any>);
  }

  save(path: string, data: string | undefined): Promise<any> {
    return (this.wmHttpService.execute({
      target: this.TARGET,
      action: 'write',
      data: data,
      pathParams: {
        projectID: this.projectService.getProjectId(),
        filePath: path
      }
    }) as Promise<any>);
  }

  write(filePath: string, content: any, showSpinner: boolean = true): Promise<any>{
    return (this.wmHttpService.execute({
      target: this.TARGET,
      action: 'write',
      pathParams: {
        projectID: this.projectService.getProjectId(),
        filePath: filePath
      },
      data: content,
      spinnerInfo: {
        showSpinner: showSpinner
      }
    }) as Promise<any>);
  }

  upload(uploadConfig: any): Promise<any> {
    return (this.wmHttpService.execute({
      target: this.TARGET,
      action: uploadConfig.action,
      pathParams: {
        projectID: this.projectService.getProjectId(),
        filePath: uploadConfig.path
      },
      data: uploadConfig.content
    }) as Promise<any>);
  }

  /**
     * @ngdoc function
     * @name wm.common.$FileService#getFileConfig
     * To get the file config & path
     */
  getFileConfig(param: any): Promise<any>{
    param.target = this.TARGET;
    param.action = "read";
    return this.baseservice.parseReplace(param);
  }
}
